import React from 'react';
import { ErrorBoundary } from '../error-boundary';
import { EmptyChatState } from '../empty-chat-state';

interface ChatErrorBoundaryProps {
  children: React.ReactNode;
  chatId?: string;
  subjectName?: string;
  onRetry?: () => void;
}

export function ChatErrorBoundary({ children, chatId, subjectName, onRetry }: ChatErrorBoundaryProps) {
  const handleError = (error: Error) => {
    // Log chat-specific error context
    console.error('Chat error:', { chatId, subjectName, error });
    
    // Could send to analytics/monitoring service
    // analytics.track('chat_error', { chatId, error: error.message });
  };

  const chatErrorFallback = (
    <EmptyChatState 
      type="load-error"
      subjectName={subjectName}
      chatId={chatId}
      onRetry={onRetry}
    />
  );

  return (
    <ErrorBoundary
      level="component"
      onError={handleError}
      fallback={chatErrorFallback}
    >
      {children}
    </ErrorBoundary>
  );
}
